import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "react-bootstrap";
import Button from "../../components/global/button/Button";
import logo from "../../assets/images/logo/app-logo.svg";

import SectionLoader from "../../components/global/loader/SectionLoader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import {
  EnhancedTableHead,
  getComparator,
  stableSort,
} from "../../components/dashboard/table_component/TableComponent";

import { getAppointmentList } from "../../services/api_services/AppointmentServices";
import {
  convertDateAndTimeToString,
  getSelectedBranchId,
  searchResult,
} from "../../utils/HelperFunctions";
import { SEARCH_RESULT_FOR_APPOINTMENT } from "../../utils/Constants";

export default function SelectAppointmentModal(props) {
  const [headCells] = useState([
    {
      id: "checkBox",
      numeric: false,
      disablePadding: false,
      label: "",
      disableSorting: true,
    },
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "Appo. ID",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Name",
    },
    {
      id: "reason",
      numeric: false,
      disablePadding: false,
      label: "Reason",
    },
    {
      id: "visitDate",
      numeric: false,
      disablePadding: false,
      label: "Date and Time",
    },
    ...(props.isConsultantUser
      ? []
      : [
          {
            id: "consultantName",
            numeric: false,
            disablePadding: false,
            label: "Consultant",
          },
        ]),
    {
      id: "branch-location",
      numeric: false,
      disablePadding: false,
      label: "Branch Location",
    },
  ]);

  const [selectedItems, setSelectedItems] = useState(() => {
    const initialSelections = {};
    props?.preSelectedFilterItems?.forEach((id) => {
      initialSelections[id] = true;
    });
    return initialSelections;
  });
  const [isAPILoading, setIsAPILoading] = useState(false);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selected, setSelected] = useState(null);

  const [appointmentList, setAppointmentList] = useState([]);
  const [totalAppointmentCount, setTotalAppointmentCount] = useState(0);
  const [selectedAppointment, SetSelectedAppointment] = useState(null);
  const [searchData, setSearchData] = useState("");

  useEffect(() => {
    if (props.show) {
      if (
        props?.preSelectedFilterItems &&
        props?.preSelectedFilterItems.length > 0
      ) {
        setSelectedItems(() => {
          const initialSelections = {};
          props?.preSelectedFilterItems?.forEach((id) => {
            initialSelections[id] = true;
          });
          return initialSelections;
        });
        setSelected(parseInt(props?.preSelectedFilterItems[0]));
        SetSelectedAppointment(props?.selectedAppointment);
      } else {
        setSelectedItems([]);
        SetSelectedAppointment(null);
        setSelected(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  useEffect(() => {
    if (props.show) {
      getAllAppointmentList(searchData, page, rowsPerPage);
      setIsAPILoading(false);
    }
  }, [props.show, page, rowsPerPage, searchData]);

  useEffect(() => {
    if (props.show) {
      const handleBranchChange = () => {
        setPage(0);
        getAllAppointmentList(searchData, page, rowsPerPage);
      };

      window.addEventListener("branchChanged", handleBranchChange);

      return () => {
        window.removeEventListener("branchChanged", handleBranchChange);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData, page, rowsPerPage]);

  async function getAllAppointmentList(searchData, page, rowsPerPage) {
    let data = JSON.stringify({
      fromDate: "",
      toDate: "",
      status: "completed",
      consultantIdString: "",
      text: searchData,
      isAppointmentsWithNoInvoice: true,
      addressId: getSelectedBranchId(),
      visitType: "ALL",
    });
    setIsAPILoading(true);
    const response = await getAppointmentList(page, rowsPerPage, data);

    if (response) {
      if (response.list && response.list.length > 0) {
        setAppointmentList(response.list);
        setTotalAppointmentCount(response.count);
      } else {
        setAppointmentList([]);
        setTotalAppointmentCount(0);
      }
    }
    setIsAPILoading(false);
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const selectedIds = Object.keys(selectedItems).filter(
      (id) => selectedItems[id],
    );

    props?.setSelectedItems(selectedIds);

    if (selectedIds && selectedIds.length) {
      props?.setSelectedAppointment(selectedAppointment);

      props?.setIsAppointmentSelected(true);
    } else {
      props?.setSelectedAppointment("");
      props?.setIsAppointmentSelected(false);
    }
    setSearchData("");
    props.onHide();
    setSelectedItems([]);
  };

  function handleChangePage(event, newPage) {
    setPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setPage(0);
    setRowsPerPage(event.target.value);
  }
  function handleRequestSort(event, property) {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  }

  const getColumnIndex = (label) => {
    return headCells.findIndex((cell) => cell.label === label);
  };

  const handleCheckboxChange = (id, index, row, e) => {
    const checked = e.target.checked;

    if (checked) {
      setSelected(id);
      SetSelectedAppointment(row);
    } else {
      setSelected(null);
      SetSelectedAppointment(null);
    }

    setSelectedItems((prevSelectedAppointments) => {
      const newSelections = {
        ...prevSelectedAppointments,
        [id]: !prevSelectedAppointments[id],
      };
      return newSelections;
    });
  };

  return (
    <Modal
      size="lg"
      centered
      show={props.show}
      dialogClassName="select-appointment-modal"
    >
      <form onSubmit={handleSubmit}>
        <ModalHeader className="justify-content-center">
          <div>
            <img src={logo} alt="" height="30" className="ms-5 text-center" />
            <h6 className="mt-2 mb-0 txt-secondary text-center">
              Select Appointment from below list.
            </h6>
          </div>
        </ModalHeader>
        <ModalBody>
          <>
            <div className=" px-3">
              <div className="form-floating mb-3">
                <input
                  type="search"
                  className="form-control"
                  id="searchAppointment"
                  placeholder="Search By Id, Name"
                  value={searchData}
                  onChange={(e) => {
                    setSearchData(e.target.value);
                    setPage(0);
                  }}
                />
                <label htmlFor="searchAppointment">Search By Id, Name</label>
              </div>

              {isAPILoading ? (
                <SectionLoader />
              ) : appointmentList.length !== 0 ? (
                <>
                  <TableContainer id="tableDiv">
                    <Table className="tableX" aria-labelledby="tableTitle">
                      <EnhancedTableHead
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={appointmentList.length}
                        headCells={headCells}
                      />
                      <TableBody className="table">
                        {stableSort(
                          appointmentList,
                          getComparator(order, orderBy),
                        ).map((row, index) => {
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              key={"Appointment-" + row.id}
                              style={{ backgroundColor: row.colorCode }}
                            >
                              <TableCell data-cell={headCells[1].label}>
                                <input
                                  type="checkbox"
                                  checked={!!selectedItems[row.id]}
                                  disabled={
                                    (selected !== null &&
                                      selected !== row.id) ||
                                    row.clientId === null
                                  }
                                  onChange={(e) =>
                                    handleCheckboxChange(row.id, index, row, e)
                                  }
                                  className="form-check-input"
                                />
                              </TableCell>
                              <TableCell
                                data-cell={
                                  headCells[getColumnIndex("Appo. ID")].label
                                }
                              >
                                {row.id}
                              </TableCell>
                              <TableCell
                                className="text-capitalize"
                                data-cell={
                                  headCells[getColumnIndex("Name")].label
                                }
                              >
                                {row.name ? row.name : "-"}
                              </TableCell>
                              <TableCell
                                className="text-capitalize"
                                scope="row"
                                data-cell={
                                  headCells[getColumnIndex("Reason")].label
                                }
                              >
                                {row.reason ? row.reason : "-"}
                              </TableCell>
                              <TableCell
                                data-cell={
                                  headCells[getColumnIndex("Date and Time")]
                                    .label
                                }
                              >
                                {convertDateAndTimeToString(row.visitDate)}
                              </TableCell>
                              {!props.isConsultantUser && (
                                <TableCell
                                  className="text-capitalize"
                                  data-cell={
                                    headCells[getColumnIndex("Consultant")]
                                      .label
                                  }
                                >
                                  {row.consultantName}
                                </TableCell>
                              )}

                              <TableCell
                                className="text-capitalize"
                                data-cell={
                                  headCells[getColumnIndex("Branch Location")]
                                    .label
                                }
                              >
                                {row?.addressDto?.addressLine1}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    className="table-pagination"
                    rowsPerPageOptions={[5, 10, 20, 40, 60, 80, 100]}
                    component="div"
                    count={totalAppointmentCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    showLastButton={true}
                    showFirstButton={true}
                  />
                </>
              ) : (
                <p className="text-center">
                  {searchData
                    ? searchResult(searchData)
                    : SEARCH_RESULT_FOR_APPOINTMENT}
                </p>
              )}
            </div>
          </>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" disabled={selected === null ? true : false}>
            Submit
          </Button>
          <Button
            className="secondary outline"
            type="reset"
            onClick={() => {
              if (selected == null) {
                setPage(0);
                setRowsPerPage(5);
              }
              setSearchData("");
              setSelectedItems([]);
              setSelected(null);
              props.onHide();
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
